import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Admin from './Admin';
import { getFirebaseApp } from './firebase';
import reportWebVitals from './reportWebVitals';

getFirebaseApp();

const path = window.location.pathname.replace(/\/+$/, '').toLowerCase();
const isAdminRoute = path === '/admin' || path.startsWith('/admin/');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isAdminRoute ? <Admin /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
